import React from "react";

import { useNavigate } from "react-router-dom";

import { Colors } from "../../assets/Colors";

const SetupPage = ({}) => {
  const navigate = useNavigate();
  let user = JSON.parse(localStorage.getItem("user"));
  return (
    <div className="md:ml-64">
      <div className="w-full flex flex-col items-center">
        <div className="w-full px-4 my-4 ">
          <div
            style={{ borderColor: Colors.primary }}
            className="flex flex-col border rounded"
          >
            <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
              {/*{user.Otoritas.SCuti !== 0 && (*/}
              {/*    <div*/}
              {/*        onClick={() => navigate("/setup-cuti")}*/}
              {/*        className="w-full md:w-1/4 cursor-pointer"*/}
              {/*    >*/}
              {/*        <div*/}
              {/*            style={{borderColor: Colors.primary}}*/}
              {/*            className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"*/}
              {/*        >*/}
              {/*            <p className="pl-2">Cuti</p>*/}
              {/*        </div>*/}
              {/*    </div>*/}
              {/*)}*/}
              {user.Otoritas.SLembur !== 0 && (
                <div
                  onClick={() => navigate("/setup-lembur")}
                  className="w-full md:w-1/4 cursor-pointer"
                >
                  <div
                    style={{ borderColor: Colors.primary }}
                    className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                  >
                    <p className="pl-2">Lembur</p>
                  </div>
                </div>
              )}
              {user.Otoritas.SJamKerja !== 0 && (
                <div
                  onClick={() => navigate("/setup-jam-kerja")}
                  className="w-full md:w-1/4 cursor-pointer"
                >
                  <div
                    style={{ borderColor: Colors.primary }}
                    className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                  >
                    <p className="pl-2">Jam Kerja</p>
                  </div>
                </div>
              )}
              {user.Otoritas.SPlafonPerobatan !== 0 && (
                <div
                  onClick={() => navigate("/setup-plafon-perobatan")}
                  className="w-full md:w-1/4 cursor-pointer"
                >
                  <div
                    style={{ borderColor: Colors.primary }}
                    className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                  >
                    <p className="pl-2">Plafon Perobatan</p>
                  </div>
                </div>
              )}
              {user.Otoritas.SAuth !== 0 && (
                <div
                  onClick={() => navigate("/setup-user")}
                  className="w-1/4 cursor-pointer"
                >
                  <div
                    style={{ borderColor: Colors.primary }}
                    className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                  >
                    <p className="pl-2">User</p>
                  </div>
                </div>
              )}
              {user.Otoritas.SApproval !== 0 && (
                <div
                  onClick={() => navigate("/setup/approval")}
                  className="w-1/4 cursor-pointer"
                >
                  <div
                    style={{ borderColor: Colors.primary }}
                    className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                  >
                    <p className="pl-2">Approval</p>
                  </div>
                </div>
              )}
              {user.Otoritas.SApproval !== 0 && (
                <div
                  onClick={() => navigate("/setup-approval-pc")}
                  className="w-1/4 cursor-pointer"
                >
                  <div
                    style={{ borderColor: Colors.primary }}
                    className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                  >
                    <p className="pl-2">Approval PC</p>
                  </div>
                </div>
              )}
              {user.Otoritas.SSaldoAwal !== 0 && (
                <div
                  onClick={() => navigate("/saldo-awal")}
                  className="w-1/4 cursor-pointer"
                >
                  <div
                    style={{ borderColor: Colors.primary }}
                    className="flex items-center justify-start border py-2 px-4 mx-2 my-2 rounded"
                  >
                    <p className="pl-2">Saldo Awal</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetupPage;
